/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Draft_Count_RemovedInputs */

const en_us2_draft_count_removed = /** @type {(inputs: Draft_Count_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 out`);
	return /** @type {LocalizedString} */ (`${i?.count} out`)
	
};

const pt_br2_draft_count_removed = /** @type {(inputs: Draft_Count_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 sai`);
	return /** @type {LocalizedString} */ (`${i?.count} saem`)
	
};

const es_419_draft_count_removed = /** @type {(inputs: Draft_Count_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 sale`);
	return /** @type {LocalizedString} */ (`${i?.count} salen`)
	
};

const pt_pt2_draft_count_removed = /** @type {(inputs: Draft_Count_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 sai`);
	return /** @type {LocalizedString} */ (`${i?.count} saem`)
	
};

const fr_fr2_draft_count_removed = /** @type {(inputs: Draft_Count_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 retrait`);
	return /** @type {LocalizedString} */ (`${i?.count} retraits`)
	
};

const de_de2_draft_count_removed = /** @type {(inputs: Draft_Count_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 raus`);
	return /** @type {LocalizedString} */ (`${i?.count} raus`)
	
};

const it_it2_draft_count_removed = /** @type {(inputs: Draft_Count_RemovedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 esce`);
	return /** @type {LocalizedString} */ (`${i?.count} escono`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 out" |
* | * | "{count} out" |
*
* @param {Draft_Count_RemovedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_count_removed = /** @type {((inputs: Draft_Count_RemovedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Count_RemovedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_count_removed(inputs)
	if (locale === "es-419") return es_419_draft_count_removed(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_count_removed(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_count_removed(inputs)
	if (locale === "de-DE") return de_de2_draft_count_removed(inputs)
	if (locale === "it-IT") return it_it2_draft_count_removed(inputs)
	return en_us2_draft_count_removed(inputs)
});
export { draft_count_removed as "draft.count_removed" }